import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subscriber, Subject } from 'rxjs';

/*
   rotinas de Geolocation
*/

interface GeolocationCoords {
    lat: number;
    lng: number;
    cep?: string;
    bairro?: string;
    cidade?: string;
    estado?: string;
    uf?: string;
}

export class NavigatorGeolocation {
    location: any;
    geocodeUrl: string = environment.geocodeUrl;
    subscriber = new Subject<GeolocationCoords>();
    coords: GeolocationCoords;
    constructor(private http: HttpClient) {
    }

    static getCurrentPosition() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                let rsp: any = {};
                this.coords = { lat: position.coords.latitude, lng: position.coords.longitude };
                return this.coords;
            });

        } else return null;
    }

    /// formato esperado para pesquisa
    ///  https://maps.google.com/maps/api/geocode/json?address=${ender}&sensor=false&key=${apikey}
    getGeoLocationByAddress(ender: string): Subject<GeolocationCoords> {
        ender = ender.replace(' ', '+');
        let url = this.geocodeUrl.replace('${ender}', ender);
        console.log(url);
        this.http.get(url).subscribe((x: any) => {
            if (x.results)
                try {
                    this.location = x.results[0];
                    console.log(this.location);
                    let k = this.location.geometry.location;
                    this.coords = { lat: k.lat, lng: k.lng };
                    console.log(this.coords);

                    // procura se tem CEP
                    let comps: any[] = this.location.address_components;
                    comps.forEach(element => {
                        let tps: any[] = element.types;
                        if (tps.indexOf('postal_code') >= 0) {
                            this.coords.cep = element.long_name;
                        }
                        if (tps.indexOf('sublocality') >= 0) {
                            this.coords.bairro = element.long_name;
                        }
                        if (tps.indexOf('administrative_area_level_2') >= 0)
                            this.coords.cidade = element.long_name;
                        if (tps.indexOf('administrative_area_level_1') >= 0) {
                            this.coords.estado = element.long_name;
                            this.coords.uf = element.short_name;
                        }
                    });

                    this.subscriber.next(this.coords);
                } catch (e) { this.subscriber.error(e.message) };
        });
        return this.subscriber;
    }

    //https://www.google.com/maps/?q=-15.623037,18.388672
    verNoGooleMap(htmlID,latitude,longitude){
        let frm = window.document.getElementById('mapFrame');
        if (frm) window.document.removeChild(frm);
           
        let obj = window.document.getElementById(htmlID);
        let url = `https://www.google.com/maps/?q=${latitude},${longitude}`;
        console.log('abrindo:',url);   
        
        if (obj){
            var ifrm = document.createElement("iframe");
            ifrm.setAttribute("id","mapFrame");
            ifrm.setAttribute("src", url);
            ifrm.style.width = "200px";
            ifrm.style.height = "150px";
            obj.appendChild(ifrm);
        }
    }


    getGoogleMapUrl(latitude,longitude){
        return `https://www.google.com/maps/?q=${latitude},${longitude}`;
    }

}